import { ActionCard, ScoreBasis, Section } from '@playbooks/core/src/interfaces/ActionCard'

import { ActionCardModel } from '.'
import { MAX_SCORE_LIMIT, MIN_SCORE_LIMIT } from './constants'

export default function matchElementRange(
  element: {
    scoreBased?: ScoreBasis
    minScore?: number
    maxScore?: number
    scoringDimensionId?: number
    idOfSep?: number
  },
  state: ActionCard,
) {
  if (!element.idOfSep) return true

  let matchRange = true

  const hasRange = typeof element.scoreBased === 'number'
  const minScore = typeof element.minScore === 'number' ? element.minScore : MIN_SCORE_LIMIT
  const maxScore = typeof element.maxScore === 'number' ? element.maxScore : MAX_SCORE_LIMIT

  if (element.scoreBased === ScoreBasis.SEPARATOR && hasRange) {
    const separator = new ActionCardModel(state)
      .getSearchService()
      .find(node => (node.data as Section).id === element.idOfSep).data as Section

    matchRange = compare(separator?.score ?? 0)
  }

  if (element.scoreBased === ScoreBasis.TOTAL && hasRange) {
    matchRange = compare(state.score || 0)
  }

  if (element.scoreBased === ScoreBasis.DIMENSION && hasRange) {
    const dimension = state.scoringDimensions?.find(dim => dim.id === element.scoringDimensionId)
    const dimensionScore = dimension?.actual || 0

    matchRange = compare(dimensionScore)
  }

  function compare(value: number) {
    return value >= minScore && value <= maxScore
  }

  return matchRange
}
